import axios from "axios";
import axiosInstance from "../utils/axiosConfig";
import { clearSession } from "../utils/Session";
const { BASE_URL } = require("../utils/urls");
//const API_BASE_URL = "https://panaccoapi-453601304730.asia-south1.run.app/api/auth"; // Correct full URL
// import axios from "../utils/axiosConfig";
//const API_BASE_URL = "http://localhost:8080/api/auth"; 
//const API_BASE_URL="https://panaccoapi-uat-1082177167010.asia-south1.run.app/api/auth"
const API_BASE_URL=`${BASE_URL}/api/auth`
interface LoginData {
  userId: string;
  password: string;
}

interface ChangePasswordPayload {
  userId: string;
  oldPassword: string;
  newPassword: string;
}

interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

interface LoginResponse {
  accessToken: string;
  refreshToken:string;
  warning?: string;  
  user: {
    userId:string;
    name: string;
    email: string;
    orgId:string;
    orgName:string;
  };
}
interface ForgotPasswordPayload {
  userId: string;
}

interface ForgotPasswordResponse {
  message: string;
}
export const loginUser = async (data: LoginData): Promise<LoginResponse> => {
  try {
    // Call the correct API endpoint
    const response = await axios.post(`${API_BASE_URL}/logIn`, data);
    // Return the response data
     const res = response.data;
 
    // FIX: backend sends "warningMessage", LoginPage checks "warning"
    // Normalise here so the rest of the UI doesn't need to change
    return {
      accessToken:  res.accessToken,
      refreshToken: res.refreshToken,
      warning:      res.warningMessage ?? res.warning ?? null,  // ← handles both
      user: {
        userId:  res.user?.userId,
        orgId:   res.user?.orgId,
        orgName: res.user?.orgName,
        name:    res.user?.name,
        email:   res.user?.email,
      },
    };
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Login failed");
  }
};

export const changePassword = async (
  payload: ChangePasswordPayload
): Promise<ChangePasswordResponse> => {
  try {
    const token = localStorage.getItem("accessToken");

   const response = await axiosInstance.post(
      `${API_BASE_URL}/changePassword`,
      payload
    );

    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Password change failed"
    );
  }
};


export const forgotPassword = async (payload: ForgotPasswordPayload): Promise<ForgotPasswordResponse> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/forgotPassword`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to send password email");
  }
};

export const resetPassword = async ({ token, newPassword }: { token: string; newPassword: string }) => {
  const response = await axios.post(`${API_BASE_URL}/resetPassword`, { token, newPassword });
  return response.data;
};

export const handleLogout = async (): Promise<void> => {
  const refreshToken = localStorage.getItem("refreshToken");
  try {
    // Tell the server to revoke this refresh token in Firestore
    await axiosInstance.post(`${API_BASE_URL}/logout`, { refreshToken });
  } catch {
    // Logout should always succeed on the client side even if server call fails
  } finally {
    clearSession();
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  }
};